/* ADD Knowledge categories */
export const ADD_POSITION = "ADD_POSITION"
export const ADD_POSITION_SUCCESS = "ADD_POSITION_SUCCESS"
export const ADD_POSITION_CLEAN = "ADD_POSITION_CLEAN"
export const ADD_POSITION_ERROR = "ADD_POSITION_ERROR"
